import {
   PAYER_LOOKUP_REQUEST,
   PAYER_LOOKUP_SUCCESS,
   PAYER_LOOKUP_FAIL,
   PAYER_LOOKUP_RESET
} from '../actions/payerActions';

export const payerLookupReducer = (state = { loading: false, payerData: null }, action) => {
   switch (action.type) {
      case PAYER_LOOKUP_REQUEST:
         return { loading: true, payerData: null, error: null };
      case PAYER_LOOKUP_SUCCESS:
         return {
            loading: false,
            payerData: action.payload,
            error: null
         };
      case PAYER_LOOKUP_FAIL:
         return { loading: false, payerData: null, error: action.payload };
      case PAYER_LOOKUP_RESET:
         return { loading: false, payerData: null, error: null };
      default:
         return state;
   }
};
